module.exports = __webpack_public_path__ + "static/img/4779_phase_function_Paper_Points.667b766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4779_phase_function_Paper_Points.png
// module id = gmg1
// module chunks = 0